module.exports = __webpack_public_path__ + "img/app.180e933d.png";